/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { subscriptionFormGetResponseSchema } from './subscriptionFormGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getSubscriptionForm200Schema = z.lazy(() => subscriptionFormGetResponseSchema);

/**
 * @description 505 response
 */
export const getSubscriptionForm505Schema = z.any();

export const getSubscriptionFormQueryResponseSchema = z.lazy(() => getSubscriptionForm200Schema);
